import { Routes, Route } from "react-router-dom";
import { UserProvider } from "./context/user.jsx";
import { LanguageProvider } from "./context/language.jsx";
import useScrollToTop from "./hooks/useScrollToTop.js";
import AppsError from "./routes/apps-error.jsx";
import SurveyRouter from "./routes/survey-router.jsx";
import WelfareRouter from "./routes/welfare-router.jsx";
import EventRouter from "./routes/event-router.jsx";

const AppRoutes = () => {
  useScrollToTop();
  return (
    <>
      <Routes>
        <Route path="/survey/*" element={<SurveyRouter />} />
        <Route path="/welfare/*" element={<WelfareRouter />} />
        <Route path="/event-booking/*" element={<EventRouter />} />
        <Route path="/*" element={<AppsError />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <div className="app">
      <UserProvider>
        <LanguageProvider>
          <AppRoutes />
        </LanguageProvider>
      </UserProvider>
    </div>
  );
}

export default App;
